import React from 'react';
import styled, { css } from 'styled-components';
import { Sticky } from 'react-sticky';
import { Link } from 'gatsby';

import PageNavBar from './page-nav-bar';
import { Box } from './UIKit/system';
import ProductList from './product-list';
import { FILTER_ALL } from '../constants';

const StyledItemFilter = styled(Box)``;

const NavbarStickyContainer = styled.div`
  width: 100%;
  z-index: 10;

  ${(props) =>
    props.isSticky &&
    css`
      margin-top: 89px;
    `};
`;

const NoneFound = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  font-weight: bold;
`;

const CategoryLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  margin-right: 32px;

  &:last-of-type {
    margin-right: 0;
  }
`;

function ItemFilter({
  categories,
  products,
  activeItemsCounter,
  currentCategory,
  onCategoryChange,
  usePathBasedNavigation
}) {
  function getCategoryPath(category) {
    if (category.slug === FILTER_ALL.slug) {
      return '/products/';
    }
    return `/products/${category.slug}/`;
  }

  function renderFilters() {
    return (
      <PageNavBar.Filters withTitle>
        {categories.map((category, index) => {
          const isActive = currentCategory.slug === category.slug;

          if (usePathBasedNavigation) {
            return (
              <CategoryLink key={index} to={getCategoryPath(category)}>
                <PageNavBar.FilterLink
                  as="span"
                  active={isActive ? 'true' : ''}
                  fontSizeSmall
                >
                  {category.name}
                </PageNavBar.FilterLink>
              </CategoryLink>
            );
          }

          return (
            <PageNavBar.FilterLink
              key={index}
              active={isActive ? 'true' : ''}
              fontSizeSmall
              onClick={() => onCategoryChange(category)}
            >
              {category.name}
            </PageNavBar.FilterLink>
          );
        })}
      </PageNavBar.Filters>
    );
  }

  return (
    <StyledItemFilter>
      <Sticky topOffset={447}>
        {({ style, isSticky }) => {
          const { transform, ...restStyles } = style; // eslint-disable-line
          return (
            <NavbarStickyContainer style={restStyles} isSticky={isSticky}>
              <PageNavBar
                title={currentCategory.name}
                subtitle={'Products'}
                filters={renderFilters()}
              />
            </NavbarStickyContainer>
          );
        }}
      </Sticky>
      {activeItemsCounter === 0 && (
        <NoneFound>
          No items could be found - try adjusting or removing filters.
        </NoneFound>
      )}
      <ProductList items={products} />
    </StyledItemFilter>
  );
}

export default ItemFilter;
